"use client";

import { useState } from "react";
import { Circle } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function PortfolioOverview() {
  const [activeFilter, setActiveFilter] = useState("All");
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const filters = ["All", "Residential Projects", "Commercial & Corporate Projects"];
  const projects = [{
    id: 1,
    image: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-thumb.jpg",
    category: "Residential Projects"
  }, {
    id: 2,
    image: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Anexartisias-Apartment-Building-Renovation.jpg?v=tk99gsrxjs",
    category: "Residential Projects"
  }, {
    id: 3,
    image: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Leukothea-Office-Construction.jpg?v=7cprtkqy105",
    category: "Commercial & Corporate Projects"
  }, {
    id: 5,
    image: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Ekali-Bathroom-Renovation.jpg?v=ryoh948np8",
    category: "Residential Projects"
  }, {
    id: 6,
    image: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Pareklisia-Residence-Renovation.jpg?v=nrdcjzx3s8",
    category: "Residential Projects"
  }, {
    id: 7,
    image: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Agios-Nikolaos-Residence-Renovation.jpg?v=c82t10us3be",
    category: "Residential Projects"
  }];
  const filteredProjects = activeFilter === "All" ? projects : projects.filter(project => project.category === activeFilter);
  return <section id="portfolio-overview" className="w-full bg-primary ![padding:96px_0px_96px_0px]">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className={`mb-12 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <div className="mb-3 flex items-center justify-center">
            <p className="text-sm font-sans font-normal tracking-widest uppercase !text-[hsl(32,29%,42%)]">
              SHOWROOM EXPERIENCE
            </p>
          </div>
          <h2 className="font-display text-4xl font-bold text-foreground-primary lg:text-5xl">Featured Projects</h2>
          <p className="mt-4 text-center font-sans text-foreground-primary leading-relaxed !text-lg">Each project by <span className="font-semibold">KS LUXURY RENOVATIONS</span> reflects our commitment to refined craftsmanship and architectural integrity. We don't follow trends, we create spaces with lasting value.</p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {filteredProjects.map((project, i) => <div key={project.id} data-index={i} className={`group overflow-hidden rounded-xl border-l border-r border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-0.5 hover:scale-[1.04] hover:shadow-medium ${gridVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
          transitionDelay: gridVisible ? `${i * 50}ms` : "0ms"
        }}>
              {i === 0 ? <Link to="https://theksway.com/palodia-residence-renovation/">
                  <div className="relative group">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                    <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-2xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      Palodia Residence<br></br> Renovation
                    </div>
                  </div>
                </Link> : i === 1 ? <Link to="https://ksluxury.cloudtech.com.cy/anexartisias-apartment-building-renovation-3/">
                  <div className="relative group">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                    <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-2xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      Anexartisias Apartment Building Renovation
                    </div>
                  </div>
                </Link> : i === 3 ? <Link to="https://ksluxury.cloudtech.com.cy/ekali-bathroom-renovation-3/">
                  <div className="relative group">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                    <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-2xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      Ekali Bathroom <br></br>Renovation
                    </div>
                  </div>
                </Link> : i === 4 ? <Link to="https://ksluxury.cloudtech.com.cy/pareklisia-residence-renovation-2/">
                  <div className="relative group">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                    <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-2xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      Pareklisia Residence Renovation
                    </div>
                  </div>
                </Link> : i === 5 ? <Link to="https://ksluxury.cloudtech.com.cy/agios-nikolaos-residence-renovation-2/"> 
                  <div className="relative group">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                     <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-2xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      Agios Nikolaos Residence Renovation
                    </div>
                  </div>
                </Link> : i === 2 ? <Link to="https://ksluxury.cloudtech.com.cy/leukothea-office-construction-2/">
                  <div className="relative group/portfolio-item">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                   <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      <span className="text-white text-2xl font-bold">Leukothea Office Construction</span>
                    </div>
                  </div>
                </Link> : i === 6 ? <Link to="https://theksway.com/palodia-residence-renovation/">
                  <div className="relative group">
                    <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />
                    <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-2xl font-bold opacity-100 sm:opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-center px-6">
                      Palodia Residence Renovation
                    </div>
                  </div>
                </Link> : <img src={project.image} alt={`Portfolio project ${project.id}`} className="h-full w-full object-cover" />}
            </div>)}
        </div>

        <div className={`mt-12 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-200 ${gridVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <Link to="/projects">
          <Button className="text-sm inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-9 has-[>svg]:px-3 rounded-full bg-accent text-foreground-accent font-sans font-semibold shadow-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] !text-lg !p-6 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0">View Full Portfolio</Button>
          </Link>
          </div>
      </div>
    </section>;
}